import { render, staticRenderFns } from "./TitleDescriptionUniversal.vue?vue&type=template&id=767a9b18&scoped=true"
import script from "./TitleDescriptionUniversal.vue?vue&type=script&lang=ts"
export * from "./TitleDescriptionUniversal.vue?vue&type=script&lang=ts"
import style0 from "./TitleDescriptionUniversal.vue?vue&type=style&index=0&id=767a9b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a9b18",
  null
  
)

export default component.exports